import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/categoryData';

const articleImages = [
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20digital%20security%20illustration%20with%20soft%20warm%20lighting%2C%20abstract%20shield%20and%20lock%20concept%2C%20modern%20professional%20aesthetic%2C%20coral%20and%20amber%20accents%20on%20neutral%20background&width=600&height=400&seq=article-card-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20minimalist%20login%20and%20authentication%20concept%2C%20digital%20key%20and%20lock%20icon%2C%20warm%20soft%20lighting%2C%20clean%20professional%20design%2C%20coral%20amber%20color%20scheme%20on%20neutral%20background&width=600&height=400&seq=article-card-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Official%20announcement%20and%20megaphone%20concept%20illustration%2C%20minimalist%20document%20with%20stamp%2C%20warm%20professional%20aesthetic%2C%20amber%20gold%20accents%20on%20soft%20neutral%20background&width=600&height=400&seq=article-card-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Password%20recovery%20and%20security%20concept%2C%20abstract%20key%20and%20reset%20symbol%2C%20minimalist%20warm%20illustration%2C%20coral%20tones%20on%20clean%20neutral%20background&width=600&height=400&seq=article-card-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Identity%20verification%20and%20fingerprint%20scan%20concept%2C%20abstract%20biometric%20security%20illustration%2C%20minimalist%20warm%20professional%20design%2C%20amber%20gold%20accents&width=600&height=400&seq=article-card-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Beginners%20guide%20and%20learning%20concept%20illustration%2C%20minimalist%20book%20and%20lightbulb%2C%20warm%20soft%20lighting%2C%20clean%20professional%20aesthetic%2C%20coral%20accents%20on%20neutral%20background&width=600&height=400&seq=article-card-06&orientation=landscape',
];

export default function LatestArticles() {
  const articles = getLatestArticles(6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600">精选优质内容，助您了解更多安全知识</p>
          </div>
          <Link
            to="/category/anquan"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={articleImages[index]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 font-heading group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-time-line text-xs"></i>
                    </div>
                    {article.readTime}
                  </span>
                  <span className="text-xs font-medium text-primary-600 flex items-center gap-1 whitespace-nowrap">
                    阅读全文 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}